export default __webpack_public_path__ + "static/media/analytics.d78c6517.svg";